import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NameChangeModal({ isOpen, onClose }) {
    const navigate = useNavigate();

    const handleGoToProfile = () => {
        onClose();
        navigate('/profile');
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
            
            <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
                <div className="px-6 py-6">
                    <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-yellow-100 rounded-full">
                        <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                        </svg>
                    </div>
                    
                    <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
                        Please Update Your Name
                    </h3>
                    
                    <p className="text-sm text-gray-600 text-center mb-6">
                        We noticed you're using a default system-generated name. Please update your display name to make it easier for others to identify you.
                    </p>
                    
                    <div className="flex justify-center">
                        <button
                            onClick={handleGoToProfile}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                        >
                            Update Name
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
} 